import { render, staticRenderFns } from "./campo.vue?vue&type=template&id=88f382b0&scoped=true"
import script from "./campo.vue?vue&type=script&lang=js"
export * from "./campo.vue?vue&type=script&lang=js"
import style0 from "./campo.vue?vue&type=style&index=0&id=88f382b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88f382b0",
  null
  
)

export default component.exports